// extracted by mini-css-extract-plugin
export default {"root":"IconPointLevel_root__NT0-M","empty":"IconPointLevel_empty__qzdsL","filled":"IconPointLevel_filled__rbhgJ"};